import { sortBy } from 'underscore';
import { Distance, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * @class AlignItemsByCenterCommand
 * @extends AbstractCommand
 */
export default class AlignItemsByCenterCommand extends AbstractCommand {
    constructor(items, alignVertical) {
        super();

        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Too few items are selected.');
        }

        this.items = items;
        this.alignVertical = !!alignVertical;
        this.initialPositions = {};

        this.items.forEach(item => (this.initialPositions[item.cid] = item.get('position').clone()));
    }

    /**
     * Execute command
     */
    execute() {
        const axis = this.alignVertical ? 'y' : 'x';
        const invertAxis = this.alignVertical ? 'x' : 'y';
        let areaBounds;

        const sortedItems = sortBy(this.items, (item) => {
            const itemBounds = item.getBounds();
            const itemCenter = itemBounds.getCenter();

            if (areaBounds) areaBounds = areaBounds.merge(itemBounds);
            else areaBounds = itemBounds;

            return (itemCenter[axis] * 100000) + itemCenter[invertAxis];
        });

        const newPos = areaBounds.getCenter()[axis];

        sortedItems.forEach((item) => {
            const initialPosition = item.get('position').clone();
            const itemBounds = item.getBounds();
            const distance = new Distance(initialPosition, itemBounds.getCenter()).point;

            initialPosition[axis] = newPos - distance[axis];
            item.set('position', initialPosition);
        });
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.items.forEach(item => item.set('position', this.initialPositions[item.cid]));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Align items by center ${this.alignVertical ? 'vertical' : 'horizontal'}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.AlignItemsByCenterCommand = AlignItemsByCenterCommand;
